import styled from "styled-components";

export const AppConfigText = styled.span`
    margin-bottom: 1em;
    display: block;
    text-align: center;
`;